import { Dictionary, sortedIndexBy } from 'lodash';
import { TimeSeries, NumericDataPoint } from '../models';

export const lookupPrevious = (timeSeries: Dictionary<TimeSeries>, at: Date) => {
  const previous: Dictionary<number | undefined> = {};

  const comp = (v: NumericDataPoint) => v.time;

  Object.keys(timeSeries).forEach((tagId) => {
    const series = timeSeries[tagId];
    const idx = sortedIndexBy(series.points, { time: at, value: 0, quality: '', id: '' }, comp);

    if (
      series.points.length > 0 &&
      series.points[idx - 1] &&
      series.points[idx - 1].value !== null
    ) {
      previous[tagId] = series.points[idx - 1].value as number;
    } else {
      previous[tagId] = undefined;
    }
  });

  return previous;
};
